import React, { useEffect } from "react"
import { useValidatorSeeker } from "@app"
import { NumberFieldSeeker } from "@ui-seeker/core"
import { object, string } from "yup"

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsComparatorValue() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().comparatorValue)

	const { errors, isValid } = useValidatorSeeker({ comparatorValue: dataInfo.value }, object({
		comparatorValue: string().test('comparator', 'Please provide a number between 0 and 100', c => c >= 0 && c <= 100)
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.peek(), comparatorValue: isValid }
	}, [JSON.stringify(errors)])

	return <NumberFieldSeeker
		label="Value"
		placeholder="Value to compare"
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'comparatorValue')}
		error={errors.comparatorValue}
	/>
}